import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";
import { Box } from "@material-ui/core";
import { ChangeEvent, useEffect, useState } from "react";
import getCashGameData from "../../utils/getCashGameData";
import { CashGame } from "../../interfaces/cashGame";

const CompletedCashGame = ({
    closeWindow,
    players,
    cost,
    gameTitle,
    date,
    months,
}: {
    closeWindow: () => void;
    players: string[];
    cost: string;
    date: Date;
    gameTitle: string;
    months: string[];
}) => {
    const [gameData, setGameData] = useState<CashGame>();
    const [first, setFirst] = useState<string>("");
    const [second, setSecond] = useState<string>("");
    const [third, setThird] = useState<string>("");
    const [fourth, setFourth] = useState<string>("");
    const [fifth, setFifth] = useState<string>("");
    const [sixth, setSixth] = useState<string>("");
    const [seventh, setSeventh] = useState<string>("");
    const [eigth, setEigth] = useState<string>("");

    const [firstValue, setFirstValue] = useState<number>();
    const [secondValue, setSecondValue] = useState<number>();
    const [thirdValue, setThirdValue] = useState<number>();
    const [fourthValue, setFourthValue] = useState<number>();
    const [fifthValue, setFifthValue] = useState<number>();
    const [sixthValue, setSixthValue] = useState<number>();
    const [seventhValue, setSeventhValue] = useState<number>();
    const [eigthValue, setEightValue] = useState<number>();

    const updateCashStatus = async (e: any) => {
        // don't refresh
        e.preventDefault();
        const request = await fetch(
            `${process.env.REACT_PUBLIC_API_URL}/completeCashGame`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    day: date.getDate(),
                    month: months[date.getMonth()],
                }),
            }
        );

        const response = await request.json();

        if (response.success) {
            alert("Game status updated");
        } else {
            alert("Error in updating game status");
        }
    };

    // when the complete game form is submitted
    const finishGameHandler = (e: any) => {
        // update player stats
        updateCashStatus(e);
        window.location.reload();
    };

    const init = async () => {
        setGameData((await getCashGameData(gameTitle)) as CashGame);
    }

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        if (players.length === 0) {
            return;
        }
        setFirst(players[0]);

        if (1 < players.length) {
            setSecond(players[1]);
        }
        if (2 < players.length) {
            setThird(players[2]);
        }
        if (3 < players.length) {
            setFourth(players[3]);
        }
        if (4 < players.length) {
            setFifth(players[4]);
        }
        if (5 < players.length) {
            setSixth(players[5]);
        }
        if (6 < players.length) {
            setSeventh(players[6]);
        }
        if (7 < players.length) {
            setEigth(players[7]);
        }
    }, [gameData])

    return (
        <>
            <Card sx={{ minWidth: 275, border: 2 }}>
                <CardContent>
                    <Box style={{ float: "right" }}>
                        <ClearIcon onClick={closeWindow} />
                    </Box>
                    <Box>
                        <Typography style={{ marginBottom: "1rem" }}>
                            Enter Game Results:
                        </Typography>
                    </Box>
                    <div style={{ margin: "auto" }}>
                        <br />
                        <form
                            style={{
                                marginRight: "2rem"
                            }}>

                            <div>
                                {(first !== "") ?
                                    <div>
                                        <label htmlFor="first">{first}:</label><br></br>
                                        <input
                                            type="text"
                                            id="first"
                                            name="title"
                                            value={firstValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setFirstValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />

                                    </div>
                                    :
                                    <></>
                                }
                                {(second !== "") ?
                                    <div>
                                        <label htmlFor="second">{second}</label><br></br>
                                        <input
                                            type="text"
                                            id="second"
                                            name="title"
                                            value={secondValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setSecondValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(third !== "") ?
                                    <div>
                                        <label htmlFor="third">{third}</label><br></br>
                                        <input
                                            type="text"
                                            id="third"
                                            name="title"
                                            value={thirdValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setThirdValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(fourth !== "") ?
                                    <div>
                                        <label htmlFor="fourth">{fourth}</label><br></br>
                                        <input
                                            type="text"
                                            id="fourth"
                                            name="title"
                                            value={fourthValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setFourthValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(fifth !== "") ?
                                    <div>
                                        <label htmlFor="fifth">{fifth}</label><br></br>
                                        <input
                                            type="text"
                                            id="fifth"
                                            name="title"
                                            value={fifthValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setFifthValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(sixth !== "") ?
                                    <div>
                                        <label htmlFor="sixth">{sixth}</label><br></br>
                                        <input
                                            type="text"
                                            id="sixth"
                                            name="title"
                                            value={sixthValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setSixthValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(seventh !== "") ?
                                    <div>
                                        <label htmlFor="seventh">{seventh}</label><br></br>
                                        <input
                                            type="text"
                                            id="seventh"
                                            name="title"
                                            value={seventhValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setSeventhValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                                {(eigth !== "") ?
                                    <div>
                                        <label htmlFor="eigth">{eigth}</label><br></br>
                                        <input
                                            type="text"
                                            id="eigth"
                                            name="title"
                                            value={eigthValue}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                setEightValue(parseInt(e.target.value))
                                            }
                                            className="input-field"
                                            placeholder="First place"
                                            style={{
                                                marginBottom: "2rem",
                                                width: "200px",
                                            }}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                            <CardActions style={{ justifyContent: "center" }}>
                                <Button
                                    size="small"
                                    onClick={finishGameHandler}
                                >
                                    Submit
                                </Button>
                            </CardActions>
                        </form>
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default CompletedCashGame;
